<template>
    <div v-if="isOpen" class="modal fade show d-block" tabindex="-1" @click.self="closeModal">
        <div class="modal-dialog">
            <div class="modal-content" :class="{ 'modal-dark': darkMode, 'modal-light': !darkMode }">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                    <button type="button" class="btn-close" @click="closeModal">
                        <i class="bi bi-x-lg"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <component :is="selectedFormComponent" :selectedData="selectedData"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import 'bootstrap-icons/font/bootstrap-icons.css';
import { computed } from "vue";
import { useStore } from "vuex";
const store = useStore();
const darkMode = computed(() => store.state.darkMode);

defineProps({
    isOpen: Boolean,
    title: String,
    selectedFormComponent: Object,
    selectedData: Object
});

const emit = defineEmits(["close"]);

const closeModal = () => {
    emit("close");
};
</script>

<style scoped>
.modal-dark {
    background-color: #111c44;
    color: #ffffff;
}

.modal-light {
    background-color: #ffffff;
    color: #000000;
}

.modal {
    background: rgba(0, 0, 0, 0.5);
}
</style>
